module.exports = __webpack_public_path__ + "979ba200b84b46bf2833667627ceda53.pdf";